/* eslint-disable react/no-array-index-key */

import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing4, Spacing12 } from 'autogen/design-tokens/tokens';
import type { EmaLogoViewModel, SplashModel } from 'autogen/swagger/all';
import { EMAAltText } from 'autogen/translation-keys/trans-website-imagealttext';
import LinkAction from 'components/shared/Routing/components/LinkAction/LinkAction';
import { ImageSplash, PictogramSplash } from 'components/shared/Splash';
import { filterSplashesByImage } from 'components/shared/Splash/shared/helpers';

const Overlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
`;

const PictogramContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: grid;
    align-content: end;
    gap: ${Spacing4};
`;

const SupplimentarySplashes = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: ${Spacing12};
`;

const EmaLogoContainer = styled(LinkAction)`
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    pointer-events: auto;
`;

const EmaLogo = styled.img`
    max-width: 110px;
    max-height: 90px;
`;

export default function SplashOverlay({
    splashes,
    emaLogo
}: {
    splashes?: SplashModel;
    emaLogo?: EmaLogoViewModel;
}): JSX.Element {
    const { extra, supplimentary } = splashes || {};
    const pictogramSplashes = extra?.filter((splash) => splash.type === 'Hazard');
    const imageSplashes = filterSplashesByImage(supplimentary);
    const { t } = useTranslation();

    return (
        <Overlay>
            {!!pictogramSplashes?.length && (
                <PictogramContainer>
                    {pictogramSplashes.map((splash, index) => (
                        <PictogramSplash key={index} {...splash} size="xl" />
                    ))}
                </PictogramContainer>
            )}
            {!!imageSplashes?.length && (
                <SupplimentarySplashes>
                    {!!imageSplashes?.length &&
                        imageSplashes.map((splash, index) => (
                            <ImageSplash key={index} {...splash} size={{ xs: 'md', xl: 'xl' }} />
                        ))}
                </SupplimentarySplashes>
            )}
            {emaLogo && (
                <EmaLogoContainer action={emaLogo.informationUrl} aria-label={t(EMAAltText)}>
                    <EmaLogo src={emaLogo.imageUrl} alt="" />
                </EmaLogoContainer>
            )}
        </Overlay>
    );
}
